const firstLevelMenuItems = document.querySelectorAll('.menu__item.grandparent');
const secondLevelMenuItems = document.querySelectorAll('.navlink.navlink--child');
const thirdLevelMenuItems = document.querySelectorAll('.navlink.navlink--grandchild'); // Added for grandchild links

/*
$(document).ready(function() {
$(".menu__item.grandparent").hover(function() {
        $("#shopify-section-announcement #Announcement--announcement p").hide();
    }, function() {
        $("#shopify-section-announcement #Announcement--announcement p").show();
    });
});
*/

// Function to hide all paragraphs inside .announcement__text elements
const hideAnnouncementText = () => {
  document.querySelectorAll('.announcement__text p').forEach(p => {
    p.style.display = 'none';
  });
};




// Function to show all paragraphs inside .announcement__text elements
const showAnnouncementTextIfMenuClosed = () => {
  // Select the mega menu element
  const megaMenu = document.querySelector('.header__dropdown');

  // Check if the mega menu is visible
  if (!megaMenu.classList.contains('is-visible')) {
    // Show announcement text if the mega menu is not visible
    document.querySelectorAll('.announcement__text p').forEach(p => {
      p.style.display = 'block'; // Adjust the display style as needed
    });
  }
};


const findActiveMenuCollections = (e) => {
  if (e.target.classList.contains('grandparent')) {
    return e.target.querySelector('.sub-collections');
  } else {
    return e.target.closest('.header__dropdown__inner').querySelector('.sub-collections');
  }
};

const hideElement = (element) => {
  element.classList.add('hidden');
};

const unhideElement = (element) => {
  element.classList.remove('hidden');
};

const updateSubcollections = (e) => {
  hideAnnouncementText(); // Hide all announcement slides when menu item is interacted with

  // Determine if the event is coming from a grandchild link
  const isGrandchildLink = e.target.classList.contains('navlink--grandchild');
  let targetElement = e.target;

  // If it's a grandchild link, use its parent (child link) to get the data attributes
  if (isGrandchildLink) {
    targetElement = e.target.closest('.dropdown__family').querySelector('.navlink--child');
  }

  const activeMenuCollections = findActiveMenuCollections(e);
  const firstSubcollection = activeMenuCollections.querySelector('.collection_link_one');
  const secondSubcollection = activeMenuCollections.querySelector('.collection_link_two');

  if (firstSubcollection && secondSubcollection) {
    let collectionImageOneData = targetElement.getAttribute('data-collection-1-image') || undefined;
    let collectionTitleOneData = targetElement.getAttribute('data-collection-1-title') || undefined;
    let collectionLinkOneData = targetElement.getAttribute('data-collection-1-link') || undefined;
    let collectionImageTwoData = targetElement.getAttribute('data-collection-2-image') || undefined;
    let collectionTitleTwoData = targetElement.getAttribute('data-collection-2-title') || undefined;
    let collectionLinkTwoData = targetElement.getAttribute('data-collection-2-link') || undefined;

    const firstCollectionTitle = firstSubcollection.querySelector('.collection_title');
    const firstCollectionImage = firstSubcollection.querySelector('.collection_image img');
    const secondCollectionTitle = secondSubcollection.querySelector('.collection_title');
    const secondCollectionImage = secondSubcollection.querySelector('.collection_image img');

    if (!collectionImageOneData || !collectionTitleOneData || !collectionLinkOneData) {
      hideElement(firstSubcollection);
    }
    if (!collectionImageTwoData || !collectionTitleTwoData || !collectionLinkTwoData) {
      hideElement(secondSubcollection);
    }

    if (collectionImageOneData && collectionTitleOneData && collectionLinkOneData) {
      firstCollectionTitle.textContent = collectionTitleOneData;
      firstCollectionImage.setAttribute('src', collectionImageOneData);
      firstCollectionImage.setAttribute('srcset', collectionImageOneData);
      firstSubcollection.setAttribute('href', collectionLinkOneData);
      unhideElement(firstSubcollection);
    }

    if (collectionImageTwoData && collectionTitleTwoData && collectionLinkTwoData) {
      secondCollectionTitle.textContent = collectionTitleTwoData;
      secondCollectionImage.setAttribute('src', collectionImageTwoData);
      secondCollectionImage.setAttribute('srcset', collectionImageTwoData);
      secondSubcollection.setAttribute('href', collectionLinkTwoData);
      unhideElement(secondSubcollection);
    }
  }
};

// Add event listeners to first, second, and third level menu items
[firstLevelMenuItems, secondLevelMenuItems, thirdLevelMenuItems].forEach(collection => {
  collection.forEach(item => {
    item.addEventListener('mouseenter', updateSubcollections);
    item.addEventListener('mouseleave', showAnnouncementTextIfMenuClosed);
  });
});
